<div class="info-accordion-content">
  <ng-template [ngTemplateOutlet]="lazyContent && lazyContent.content" />
  <ng-content />
</div>
